module.exports = __webpack_public_path__ + "img/shuixian1.a2697844.png";